export default __webpack_public_path__ + "static/dont-icon-color-ca90317197a003c18efd1542c4e3f371c4e4ba98665b9c1fd7d5fc6d6339f3d4.png";